import { SUGGESTION_REQUEST } from "../actions/utilities";

const INITIAL_STATE = {
    getSuggestionLoading: false,
    getSuggestionSuccess: false,
    getSuggestionFailure: false,
    getSuggestionError: null,
    addSuggestionLoading: false,
    addSuggestionSuccess: false,
    addSuggestionFailure: false,
    addSuggestionError: null,
    suggestions: []
}

export const suggestionReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SUGGESTION_REQUEST.GET_SUGGESTIONS_REQUEST:
            return {
                ...state,
                getSuggestionLoading: true,
                getSuggestionSuccess: false,
                getSuggestionFailure: false,
                getSuggestionError: null,
            }
        case SUGGESTION_REQUEST.GET_SUGGESTIONS_SUCCESS:
            return {
                ...state,
                getSuggestionLoading: false,
                getSuggestionSuccess: true,
                getSuggestionFailure: false,
                getSuggestionError: null,
                suggestions: action.payload
            }
        case SUGGESTION_REQUEST.GET_SUGGESTIONS_FAILURE:
            return {
                ...state,
                getSuggestionLoading: false,
                getSuggestionSuccess: false,
                getSuggestionFailure: true,
                getSuggestionError: action.payload,
            }
        case SUGGESTION_REQUEST.ADD_SUGGESTIONS_REQUEST:
            return {
                ...state,
                addSuggestionLoading: true,
                addSuggestionSuccess: false,
                addSuggestionFailure: false,
                addSuggestionError: null,
            }
        case SUGGESTION_REQUEST.ADD_SUGGESTIONS_SUCCESS:
            var x = state.suggestions;
            x.push(action.payload);
            return {
                ...state,
                addSuggestionLoading: false,
                addSuggestionSuccess: true,
                addSuggestionFailure: false,
                addSuggestionError: null,
                suggestions: x
            }
        case SUGGESTION_REQUEST.ADD_SUGGESTIONS_FAILURE:
            return {
                ...state,
                addSuggestionLoading: false,
                addSuggestionSuccess: false,
                addSuggestionFailure: true,
                addSuggestionError: action.payload
            }
        case SUGGESTION_REQUEST.EDIT_SUGGESTION_STATUS:
            let y = state.suggestions;
            
            for (var i = 0; i < y.length; i++){
                if (y[i].suggestionId === action.payload.id){
                    y[i].status = action.payload.value;
                }
            }
            
            return{
                ...state,
                suggestion: y
            }

        default:
            return state;
    }
}
